import React, { ReactElement, useCallback } from 'react';
import { StatusCodes } from 'http-status-codes';
import isEqual from 'lodash.isequal';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const { error } = props;
    const statusCode = error?.statusCode;
    const isErrorTimeout = statusCode === StatusCodes.GATEWAY_TIMEOUT;

    const handleReloadClick = useCallback(
      (): void => {
        window.location.reload();
      },
      [],
    );

    const injectedProps: InjectedProps = {
      onReloadClick: handleReloadClick,
      isErrorTimeout,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};

export { withContainer };
